import { useEffect, useRef } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogViewChoiceFolder = (visible: boolean) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const loggedRef = useRef(false);

  useEffect(() => {
    if (!visible) {
      loggedRef.current = false;
      return;
    }
    if (loggedRef.current) return;
    loggedRef.current = true;
    logAnalyticsEvent({ name: 'VIEW_CHOICE_FOLDER' });
  }, [visible, logAnalyticsEvent]);
};
